import { Column, Item, Row } from 'components/ui-blocks/placeholder';
import type { MemoryEmptyStates } from 'factories/timeline';
import React, { PureComponent } from 'react';
import styles from './MemoryGroupPlaceholder.module.scss';

interface Props {
  numItems: number;
  isLoading: boolean;
  emptyType: null | MemoryEmptyStates;
}

export class MemoryGroupPlaceholder extends PureComponent<Props> {
  static defaultProps = {
    numItems: 5,
  };

  render() {
    const { numItems } = this.props;
    const placeholders = new Array(numItems).fill(0);

    // Render placeholders for Memory Groups
    return (
      <div className={styles.placeholderContainer} key="placeholder-container">
        <Item key="placeholder-heading">
          <Column span={12}>
            <Row>
              <Column span={4} />
              <Column span={8} empty />
            </Row>
          </Column>
        </Item>
        {placeholders.map((_, index) => {
          return (
            <Item key={index}>
              <Column span={12}>
                <Row>
                  <Column span="half" />
                  <Column span="half" empty />
                  <Column span={4} />
                  <Column span={6} empty />
                  <Column span="half" empty />
                  <Column span="half" />
                </Row>
                <Row>
                  <Column span={1} empty />
                  <Column span={5} />
                  <Column span={5} empty />
                  <Column span="half" empty />
                  <Column span="half" />
                </Row>
              </Column>
            </Item>
          );
        })}
      </div>
    );
  }
}
